import React from 'react'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

export interface SettingsMenuItemProps {
  className?: string
  titleClassName?: string
  title: string
  subtitle?: string
  icon?: () => React.ReactNode
  /** When true, renders title as-is without calling t(). Use for already-translated strings. */
  skipTranslation?: boolean
}

export const SettingsMenuItem = ({
  className,
  titleClassName,
  title,
  subtitle,
  icon,
  skipTranslation,
}: SettingsMenuItemProps) => {
  const { t } = useTranslation()
  return (
    <span className="flex items-center gap-2 text-M">
      <span
        className={twMerge(
          'flex h-9 w-9 shrink-0 items-center justify-center rounded-sm',
          '[&>svg>path]:fill-iconSecondary [&>svg]:h-5 [&>svg]:w-5',
          icon && 'bg-black/5',
          className,
        )}
      >
        {icon?.()}
      </span>
      <div className="flex flex-col text-left">
        <span className={titleClassName}>
          {skipTranslation ? title : t(title)}
        </span>
        <span className="text-textTertiary">{subtitle}</span>
      </div>
    </span>
  )
}
